
(function () {
    'use strict';

    var serviceId = 'eidsService';

    angular.module('app.common')
        .factory(serviceId, eidsService);
    eidsService.$inject = ['ngDialog', '$translate', '$cookies', 'user_factory', '$q', 'userSvc', 'notifierSvc'];

    function eidsService(ngDialog, $translate, $cookies, user_factory, $q, userSvc, notifierSvc) {
        var EXPIREMIN = 60;
        var eidsInfo = null;
        var opportunityPageDetails = {
            id: null,
            name: '',
            isRent: false,
            portfolioId: null
        };

        function setTaxNoWithExpiry(taxNo) {
            if (!taxNo) {
                $cookies.remove('taxNo');
            } else {
                var expiryDate = new Date();
                expiryDate.setMinutes(expiryDate.getMinutes() + EXPIREMIN);
                $cookies.put('taxNo', taxNo, { expires: expiryDate });
            }
        }
        function setOpportunityPageDetailsWithExpiry() {
            var expiryDate = new Date();
            expiryDate.setMinutes(expiryDate.getMinutes() + EXPIREMIN);
            $cookies.put('opportunityPageDetails', JSON.stringify(opportunityPageDetails), { expires: expiryDate });
        }
        function proceedEids(taxNo, userType) {
            if (userType === 'personal') taxNo = null;
            setTaxNoWithExpiry(taxNo);
            // https://eids.ticaret.gov.tr/oturum?firmaKodu=3D9D362F-D38D-4A49-9EA8-9AFA37B7DEA9
            window.location.href = "https://eids.ticaret.gov.tr/oturum?firmaKodu=3D9D362F-D38D-4A49-9EA8-9AFA37B7DEA9";
            // window.location.href = "http://localhost:8080/tr/publishlisting?yetkiKodu=mcWDVLbcb20LquC3Iu06&durum=Basarili"verifyEids('test');

        }
        function verifyEids(id, name, isRent, portfolioId) {
            opportunityPageDetails = {
                id,
                name,
                isRent,
                portfolioId
            };
            setOpportunityPageDetailsWithExpiry();
            function openDialog() {
                ngDialog.open({
                    templateUrl: 'app/common/eidsVerifyModal.html',
                    showClose: false,
                    closeByEscape: false,
                    closeByNavigation: false,
                    closeByDocument: false,
                    controller: ['$scope', ($scope) => {
                        $scope.onModal = true;
                        $scope.userTypes = ['personal', 'corporate'];
                        if (isCommercial) {
                            $scope.userType = $scope.userTypes[1];
                        } else {
                            $scope.userType = $scope.userTypes[0];
                        }
                        $scope.proceedEids = proceedEids;
                        $scope.taxNo = '';

                    }]
                });
            }
            var isCommercial = false;
            if (userSvc.info.Id) {
                user_factory.get_user_address({ userId: userSvc.info.Id }).$promise.then(function (result) {
                    var address = result[0];
                    isCommercial = address.isCommercial;
                }).finally(() => {
                    openDialog();
                });
            } else {
                openDialog();
            }
        }

        function checkEids() {
            var deferred = $q.defer();
            user_factory.eids_check().$promise.then(function (result) {
                if (!result.verifiedUserCode) {
                    return deferred.resolve(false);
                }
                eidsInfo = {
                    userCode: result.verifiedUserCode,
                    taxNo: result.taxNo || null
                };
                deferred.resolve(true);
            }, function (error) {
                console.log('error:', error);
                var msg;
                if (error.data.detail) {
                    msg = error.data.detail;
                } else {
                    msg = error.data;
                }
                notifierSvc.show({
                    // message: $translate.instant('eids_verify_failed'),
                    message: msg,
                    type: "error",
                });
                deferred.resolve(false);
            });
            return deferred.promise;
        }
        return {
            setTaxNo: setTaxNoWithExpiry,
            getTaxNo: function () {
                return $cookies.get('taxNo');
            },
            getOpportunityPageDetails: function () {
                return JSON.parse($cookies.get('opportunityPageDetails'));
            },
            getEidsInfo: function () {
                return eidsInfo;
            },
            setEidsInfo: function (info) {
                eidsInfo = info;
            },
            verifyEids,
            checkEids
        };

    }
})();
